export default __webpack_public_path__ + "static/media/greekgo-screenshot-02.542fed9f.png";